import { createSelector } from 'reselect';

const getUpdatesState = (state) => state.updates;

export const updatesSelector = createSelector([getUpdatesState], (updatesState) => {
  const { isFetching, error } = updatesState;

  return {
    isFetching,
    error,
  };
});
